<template>
  <EmailVerifyForm
    v-if="processStep === 'stepEmailCode'"
    @handleLoggedUser="handleLoggedUser"
    @handleError="handleError"
    @changeSubmittedStep2="changeSubmittedStep2"
    :email="email"
    :ticket="ticket"
    :submittedStep2="submittedStep2"
  ></EmailVerifyForm>
  <SmsVerifyForm
    v-else-if="processStep === 'stepSmsCode'"
    @handleLoggedUser="handleLoggedUser"
    @handleError="handleError"
    @changeSubmittedStep2="changeSubmittedStep2"
    :email="email"
    :ticket="ticket"
    :submittedStep2="submittedStep2"
  ></SmsVerifyForm>
  <DidiVerifyForm
    v-else-if="processStep === 'stepDidiCode'"
    @handleLoggedUser="handleLoggedUser"
    @handleError="handleError"
    @changeSubmittedStep2="changeSubmittedStep2"
    :email="email"
    :ticket="ticket"
    :submittedStep2="submittedStep2"
  ></DidiVerifyForm>
  <form v-else ref="formLogin" class="form--custom login__form" novalidate @submit.prevent="handleLogin">
    <h2 class="login__title">{{ $t(`${namespace}.login`) }}</h2>
    <p class="login__text">{{ $t(`${namespace}.loginText`) }}</p>

    <label for="">{{ $t(`${namespace}.corporateEmail`) }}</label>
    <v-text-field
      v-model="email"
      name="email"
      :placeholder="$t(`${namespace}.loginEmailPlaceholder`)"
      :disabled="submitted"
      v-validate="{ required: true, email: true }"
      :error-messages="errors.collect($t(`${namespace}.corporateEmailName`))"
      :data-vv-name="$t(`${namespace}.corporateEmailName`)"
      required
      flat
      outline
      solo
    />

    <div @click="tooglePasswordVisibility">
      <label for="">{{ $t(`${namespace}.accessPassword`) }}</label>
      <v-text-field
        v-model="password"
        :type="inputType ? 'password' : 'text'"
        name="password"
        placeholder="• • • • • • • •"
        append-icon="remove_red_eye"
        :disabled="submitted"
        v-validate="{ required: true }"
        :error-messages="errors.collect($t(`${namespace}.accessPasswordName`))"
        :data-vv-name="$t(`${namespace}.accessPasswordName`)"
        required
        flat
        outline
        solo
      />
    </div>

    <v-layout align-center justify-center row fill-height>
      <v-flex xs-6>
        <a
          href="#"
          class="text--link accent--text"
          v-html="$t(`${namespace}.forgotPassword`)"
          @click.prevent="toggleForm"
        />
      </v-flex>

      <v-flex xs-6>
        <v-btn
          type="submit"
          color="warning--gradient"
          :disabled="submitted"
          :loading="submitted"
          round
          block
          depressed
          large
        >
          {{ $t(`${namespace}.access`) }}
        </v-btn>
      </v-flex>
    </v-layout>

    <div class="login__or">
      <span>{{ $t('Common.or') }}</span>
    </div>

    <div class="login_disclaimer">
      {{ $t(`${namespace}.notAclientYet`) }} <a :href="smbUrl" class="text--link accent--text">{{ $t(`${namespace}.signUpNow`) }}!</a>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Omega, OmegaEventIds, OmegaBusiness, OmegaStatus } from 'common/omega'
import jwt from 'utils/jwt'
import moment from 'moment'
import userService from '@/services/user'
import Cookies from 'utils/Cookies'
import pendoInitialize from 'utils/pendo'
import { isArray } from 'utils/functions'
import EmailVerifyForm from './verifyCodeForm/EmailVerifyForm'
import DidiVerifyForm from './verifyCodeForm/DidiVerifyForm'
import SmsVerifyForm from './verifyCodeForm/SmsVerifyForm'
import {
  SESSION_USER,
  SESSION_HEADERS,
  SESSION_TIME,
  SESSION_SKIP_WIZARD,
  REDIRECT_PATH_ON_AUTH,
  SESSION_EXPIRES_TIME_VALUE,
  SESSION_EXPIRES_TIME_UNIT,
  SESSION_RAND_ID,
  NEW_PROJECT_DOMAIN,
  V3_TOKEN
} from 'utils/constants'

export default {
  name: 'LoginForm',
  components: {
    EmailVerifyForm,
    SmsVerifyForm,
    DidiVerifyForm
  },
  created () {},
  computed: {
    ...mapState({
      globalCompany: ({ company }) => company.selectedCompany
    }),

    smbUrl () {
      return process.env.NODE_ENV === 'production'
        ? 'https://corp.99app.com/cadastro'
        : 'https://corp-stg.99app.com/cadastro'
    }
  },
  data () {
    return {
      namespace: 'Views.LoginPage',
      inputType: true,
      email: null,
      password: null,
      processStep: 'stepEmailPassword',
      submitted: false,
      submittedStep2: false,
      costCenterLength: 0,
      employeesLength: 0,
      hasDefaultCostCenter: false,
      ticket: undefined
    }
  },
  methods: {
    ...mapActions({
      login: 'session/login',
      loginRequest: 'session/loginRequest',
      loginSuccess: 'session/loginSuccess',
      loginFailure: 'session/loginFailure',
      clearAlert: 'snackbarAlert/clear',
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show',
      addUserClaims: 'userClaims/add',
      updateSelectedCompany: 'company/updateSelectedCompany',
      setCostCenterCounter: 'costCenter/set',
      setSessionExpiresTime: 'sessionExpiresTime/set',
      getV3Config: 'commonConfig/getV3Config'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    toggleForm () {
      this.$emit('toggleForm')
    },

    toggleStep (stepName) {
      this.processStep = stepName || 'stepEmailCode' // 目前不给返回步骤一
      this.$emit('toggleStep')
    },

    changeSubmittedStep2 (value) {
      this.submittedStep2 = value
    },

    tooglePasswordVisibility (event) {
      if (event.target.classList.contains('v-icon')) {
        this.inputType = !this.inputType
      }
    },

    gaEventDispatch (label, val) {
      this.$ga.event(label, 'submit', val)
    },

    async pendoInitialize (user, claims) {
      if (process.env.NODE_ENV !== 'production') return

      try {
        const companiesIds = user.business.isAdministrator ? 1 : user.business.companies
        const permission = claims.find(item => item === 'ROLE_CORPORATE_USER') ? 'CorporateUser' : user.type
        const ROLE_EMPLOYEE_USER = Boolean(claims.find(item => item === 'ROLE_EMPLOYEE_USER'))
        const ROLE_GET_COMPANY_FINANCIALCONFIG = Boolean(claims.find(item => item === 'ROLE_GET_COMPANY_FINANCIALCONFIG'))

        let hasServiceBilling = null
        let isPending = null
        let useCreditCard = null
        let id = null
        let name = null
        let plan = null

        if (!ROLE_EMPLOYEE_USER && ROLE_GET_COMPANY_FINANCIALCONFIG) {
          const { data: res } = await this.$apiService.getFinancialConfigCompanies(companiesIds)
          const companies = res.data.companies[0]

          // set values
          hasServiceBilling = companies.paymentHasServiceBilling
          isPending = companies.paymentIsPending
          useCreditCard = companies.paymentUseCreditCard
          id = companies.companyId
          name = companies.companyName
          plan = companies.pod
        }

        pendoInitialize({
          user: {
            id: user.business.legacyUserId,
            permission,
            email: user.business.email,
            webCall: Boolean(claims.find(item => item === 'ROLE_POST_WEBCALL'))
          },
          payment: {
            hasServiceBilling,
            isPending,
            useCreditCard
          },
          companyInfo: {
            id,
            name,
            plan
          }
        })
      } catch (err) {
        console.log(err)
      }
    },

    async is99Admin () {
      try {
        const companyId = 1
        const { data: companyData } = await this.$apiService.getCompanyById(companyId)
        let company = companyData.data
        this.updateSelectedCompany(company)
      } catch (err) {
        console.log(err)
      }
    },

    async getWalletFinancialConfig (company) {
      try {
        const { data: walletFinancialConfig } = await this.$apiService.getWalletFinancialConfig(company.id)
        const { financialAccountId = null, periodicityConfigType = null, paymentMethod = null } = walletFinancialConfig.content

        this.updateSelectedCompany({
          ...company,
          financialAccountId,
          periodicityConfigType,
          paymentMethod
        })
      } catch (err) {
        console.log('ERROR', err)
      }
    },

    async setCompanyUser (companyId, claims) {
      try {
        const id = companyId || 1
        const ROLE_GET_COMPANY_ID_CONFIG = Boolean(claims.find(item => item === 'ROLE_GET_COMPANY_ID_CONFIG'))
        const { data: company } = await this.$apiService.getCompanyById(id)
        let plan = null

        if (ROLE_GET_COMPANY_ID_CONFIG) {
          const { data: companyConfig } = await this.$apiService.getCompanyConfig(id)
          plan = companyConfig && companyConfig.data && companyConfig.data.plan
            ? companyConfig.data.plan
            : null
        }

        const ROLE_GET_FINANCIAL_CONFIG = Boolean(claims.find(item => item === 'ROLE_GET_FINANCIAL_CONFIG'))

        if (ROLE_GET_FINANCIAL_CONFIG) {
          await this.getWalletFinancialConfig({
            ...company.data,
            plan
          })

          return
        }

        this.updateSelectedCompany({
          ...company.data,
          plan
        })
      } catch (err) {
        console.log(err)
      }
    },

    async costCenterCounter (companyId) {
      try {
        const { data: res } = await this.$apiService.getCostCentersAll(
          { limit: 1 },
          { page: 1 },
          { company: companyId }
        )
        this.costCenterLength = res.length
        this.setCostCenterCounter(res.length)
      } catch (err) {
        console.log('Error', err)
      }
    },

    async getDefaultCostCenter (companyId) {
      try {
        const { data: res } = await this.$apiService.getCostCentersAll(
          { limit: 5 },
          { page: 1 },
          { company: companyId },
          { search: 'padr' }
        )

        if (res && res.data && this.isValidArray(res.data)) {
          this.hasDefaultCostCenter = Boolean(res.data.find(item => item.name === 'Padrão'))
        }
      } catch (err) {
        console.log('Error', err)
      }
    },

    async employeesCounter (companyId) {
      try {
        const { data: res } = await this.$apiService.getEmployees(
          { limit: 1 },
          { page: 1 },
          { company: companyId }
        )
        this.employeesLength = res.length
      } catch (err) {
        console.log('Error', err)
      }
    },

    persistUserData (noClaims, user) {
      Cookies.set(SESSION_USER, JSON.stringify(noClaims), SESSION_TIME)
      localStorage.setItem(SESSION_HEADERS, JSON.stringify({ authorization: user.data.content }))
    },

    async makeSimultaneousRequests (claims, noClaims) {
      try {
        const ROLE_ADMINISTRATOR = Boolean(claims.find(item => item === 'ROLE_ADMINISTRATOR'))
        const ROLE_FINANCIAL_ADMIN = Boolean(claims.find(item => item === 'ROLE_FINANCIAL_ADMIN'))
        const ROLE_EMPLOYEE_USER = Boolean(claims.find(item => item === 'ROLE_EMPLOYEE_USER'))
        const ROLE_GET_COSTCENTER = Boolean(claims.find(item => item === 'ROLE_GET_COSTCENTER'))

        if (ROLE_ADMINISTRATOR || ROLE_FINANCIAL_ADMIN) {
          if (ROLE_GET_COSTCENTER) {
            await Promise.all([
              this.is99Admin(),
              this.setCompanyUser(1, claims),
              this.costCenterCounter(1)
            ])
          } else {
            await Promise.all([
              this.is99Admin(),
              this.setCompanyUser(1, claims)
            ])
          }
        } else if (ROLE_EMPLOYEE_USER) {
          await this.setCompanyUser(noClaims.business.companies[0], claims)
        } else {
          if (ROLE_GET_COSTCENTER) {
            await Promise.all([
              this.setCompanyUser(noClaims.business.companies[0], claims),
              this.costCenterCounter(noClaims.business.companies[0]),
              this.getDefaultCostCenter(noClaims.business.companies[0]),
              this.employeesCounter(noClaims.business.companies[0])
            ])
          } else {
            await Promise.all([
              this.setCompanyUser(noClaims.business.companies[0], claims),
              this.employeesCounter(noClaims.business.companies[0])
            ])
          }
        }
      } catch (err) {
        console.log('ERROR', err)
      }
    },

    redirectToPrivateRoute (claims) {
      try {
        const ROLE_POST_COSTCENTER = Boolean(claims.find(item => item === 'ROLE_POST_COSTCENTER'))
        const ROLE_EMPLOYEE_WIZARD = Boolean(claims.find(item => item === 'ROLE_EMPLOYEE_WIZARD'))
        const redirectOnAuth = localStorage.getItem(REDIRECT_PATH_ON_AUTH)

        if (ROLE_POST_COSTCENTER && this.costCenterLength === 0) {
          this.$router.push({ name: 'Welcome' }).catch(e => { })
        } else if (
          ROLE_EMPLOYEE_WIZARD &&
          this.hasDefaultCostCenter &&
          this.employeesLength <= 1 &&
          this.globalCompany.plan.toLowerCase() === 'smb' &&
          !localStorage.getItem(SESSION_SKIP_WIZARD)
        ) {
          this.$router.push({ name: 'Wizard' }).catch(e => { })
        } else if (redirectOnAuth) {
          localStorage.removeItem(REDIRECT_PATH_ON_AUTH)
          this.$router.push(redirectOnAuth).catch(e => { })
        } else {
          this.$router.push({ name: 'Home' }).catch(e => { })
        }
      } catch (err) {
        console.log('ERROR', err)
      }
    },

    getAttemptsRemaining (str) {
      const matchUserBlocked = /usu(?:á|a)rio(?:s)?\s+bloqueado(?:s)?/i.test(str)
      const matchAttempt = /.*(\d+).*/.exec(str)

      if (matchUserBlocked) {
        this.$emit('setAttemptsRemaining', 0)
        return
      }

      if (this.isValidArray(matchAttempt) && matchAttempt.length > 1) {
        const attempt = Number(matchAttempt[1])
        this.$emit('setAttemptsRemaining', attempt, this.processStep)
        return
      }

      this.$emit('setAttemptsRemaining', '')
      this.errorAlert(str)
    },

    async handleLogin () {
      // 登录步骤一点击登录按钮
      Omega.trackBusiness(
        OmegaEventIds.tech_b2bv3_login,
        {
          business: OmegaBusiness.login,
          type: 'step1',
          status: OmegaStatus.op
        }
      )
      const isValid1 = await this.$validator.validate(this.$t(`${this.namespace}.corporateEmailName`))
      const isValid2 = await this.$validator.validate(this.$t(`${this.namespace}.accessPasswordName`))
      const isValid = isValid1 && isValid2
      if (!isValid) return

      const { email, password } = this
      this.submitted = true
      this.clearAlert()
      this.loginRequest({ email })

      try {
        const user = await userService.login(email, password, localStorage.getItem(SESSION_RAND_ID))
        if (user.data.two_step === 'emailCode') {
          // 登录步骤二进入
          Omega.trackBusiness(
            OmegaEventIds.tech_b2bv3_login,
            {
              business: OmegaBusiness.login,
              type: 'step2',
              status: OmegaStatus.en,
              params: {
                type: 'email'
              }
            }
          )
          this.ticket = user.data.ticket
          this.toggleStep('stepEmailCode')
          this.submitted = false
        } else if (user.data.two_step === 'smsCode') {
          // 登录步骤二进入
          Omega.trackBusiness(
            OmegaEventIds.tech_b2bv3_login,
            {
              business: OmegaBusiness.login,
              type: 'step2',
              status: OmegaStatus.en,
              params: {
                type: 'sms'
              }
            }
          )
          this.ticket = user.data.ticket
          this.toggleStep('stepSmsCode')
          this.submitted = false
        } else if (user.data.two_step === 'dShield') {
          // 登录步骤二进入
          Omega.trackBusiness(
            OmegaEventIds.tech_b2bv3_login,
            {
              business: OmegaBusiness.login,
              type: 'step2',
              status: OmegaStatus.en,
              params: {
                type: 'dShield'
              }
            }
          )
          this.ticket = user.data.ticket
          this.toggleStep('stepDidiCode')
          this.submitted = false
        } else {
          this.handleLoggedUser(user)
        }
      } catch (err) {
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step1',
            status: OmegaStatus.error,
            msg: err?.message
          }
        )
        this.handleError(err)
      }
    },

    async handleLoggedUser (user) {
      const { data: userData } = user || {}
      const { code, message } = userData || {}
      // 如果命中灰度，就保存token，并跳转至v4
      if (code === '418' && message) {
        const userInfo = jwt.decode(message)
        const { business } = userInfo
        const { isAdministrator } = business
        if (isAdministrator) {
          window.location.href = process.env.VUE_APP_OPS_URL
        } else {
          localStorage.setItem(V3_TOKEN, message)
          window.location.href = process.env.VUE_APP_V4_BASE
        }
        return
      }
      if (user && user.data && user.data.valid) {
        if (user.data.rand_id) {
          localStorage.setItem(SESSION_RAND_ID, user.data.rand_id)
        }
        const token = jwt.decode(user.data.content)
        Omega.init(token?.business?.name)
        const { claims, ...noClaims } = token
        const customClaims = token.business.customClaims

        // persist data
        this.persistUserData(noClaims, user)

        /**
         * set company
         * count cost center quantity
         * count employee quantity
         */
        await this.makeSimultaneousRequests(claims, noClaims)

        // commit on store
        this.loginSuccess(noClaims)
        this.setSessionExpiresTime(moment().add(SESSION_EXPIRES_TIME_VALUE, SESSION_EXPIRES_TIME_UNIT).format())
        this.addUserClaims(claims.concat(customClaims))

        // init pendo script
        this.pendoInitialize(noClaims, claims)

        // 检查是否在iframe中
        if (window.parent !== window) {
          // 检查用户是否已注册passport和是否在灰度名单
          try {
            // const userData = { ...noClaims }
            // const response = await userService.checkPassportRegistration(userData.business.legacyUserId)
            // const { isRegistered, isInGrayscaleList } = response.data

            // 向父窗口发送登录成功消息
            window.parent.postMessage({
              type: 'LOGIN_SUCCESS',
              data: {
                user: { ...token },
                token: user.data.content,
                isPassportRegistered: false,
                isInGrayscaleList: false
              }
            }, NEW_PROJECT_DOMAIN)
          } catch (error) {
            console.error('检查passport状态失败:', error)
            // 即使检查失败，仍然发送登录成功消息，但不包含passport状态
            window.parent.postMessage({
              type: 'LOGIN_SUCCESS',
              data: {
                user: { ...token },
                token: user.data.content,
                isPassportRegistered: false,
                isInGrayscaleList: false
              }
            }, NEW_PROJECT_DOMAIN)
          }
        } else {
          // 非iframe模式下的正常处理
          // check roles ans redirect to private route
          this.redirectToPrivateRoute(claims)
        }

        this.submitted = false
        this.changeSubmittedStep2(false)
        this.gaEventDispatch('login_success', this.email)
        document.body.classList.remove('hide__chat__class')
        await this.getV3Config() // 登录成功，会去请求品类配置
        return
      }
      /** 用户登录成功后的数据回填 */
      const errorMsg = user.data && user.data.reasons
        ? user.data.reasons[0]
        : this.$t('Messages.genericError')

      this.submitted = false
      this.changeSubmittedStep2(false)
      this.loginFailure(errorMsg)
      this.errorAlert(errorMsg)

      // GA event
      this.gaEventDispatch('login_error', JSON.stringify({ email: this.email, message: errorMsg }))
    },

    handleError (error) {
      const errorMsg = error && error.response && error.response.data && error.response.data.reasons
        ? error.response.data.reasons[0]
        : this.$t('Messages.genericError')

      this.submitted = false
      this.submittedStep2 = false
      this.loginFailure(errorMsg)

      // GA event
      this.gaEventDispatch('login_error', JSON.stringify({ email: this.email, message: errorMsg }))

      if (error && error.response && error.response.status === 401) {
        this.getAttemptsRemaining(errorMsg)
        return
      }

      this.errorAlert(errorMsg)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
